function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 24,
  fill: "#D5D8DF"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#profile_lock_svg__clip0_832_1347)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M33.511 23.2a4.395 4.395 0 00-1.933-1.933 3.298 3.298 0 00-.911-.323v-1.277A6.672 6.672 0 0024 13a6.672 6.672 0 00-6.667 6.667v1.277a3.298 3.298 0 00-.91.323 4.395 4.395 0 00-1.934 1.933C14 24.156 14 25.178 14 27.222v1.556c0 2.044 0 3.066.489 4.022a4.395 4.395 0 001.933 1.933c.956.49 1.978.49 4.022.49h7.112c2.044 0 3.066 0 4.022-.49A4.395 4.395 0 0033.51 32.8c.489-.956.489-1.978.489-4.022v-1.556c0-2.044 0-3.066-.489-4.022zm-8.4 5.911c0 .611-.5 1.111-1.111 1.111s-1.111-.5-1.111-1.11v-2.223c0-.611.5-1.111 1.111-1.111s1.111.5 1.111 1.11v2.223zm-5.555-9.444A4.443 4.443 0 0124 15.222a4.443 4.443 0 014.444 4.445v1.11h-8.888v-1.11z",
  fill: "#888E98"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "profile_lock_svg__clip0_832_1347"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(14 13)",
  d: "M0 0h20v22.222H0z"
})));

var SvgProfileLock = function SvgProfileLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default SvgProfileLock;